import React, { useState } from "react";
import Filter from "../Filter";
import Search from "../Search";
import "./pageHeader.scss";
import { getNameFirstLetter, getUserData } from "../../../utils/helper";
import { IoMdArrowRoundBack } from "react-icons/io";
import useAuth from "../../../controller/auth-controller";
import BackArrow from "../../../assets/pageheader/BackArrow";
import FilterSVg from "../../../assets/pageheader/Filter";
import MoreSVg from "../../../assets/sidebar/more2";
import Tooltip from "rc-tooltip";
import { useBottomSheetContext } from "../../dialogs/bottomsheet";

function PageHeader(props) {
  const authController = useAuth();
  const { dispatch } = useBottomSheetContext();
  const userData = getUserData();
  const [sortValue, setSortValue] = useState("");
  const { logout } = authController;
  const [profileDropdown, setProfileDropdown] = useState(false);
  const {
    isFilter = false,
    options = {},
    sort = "",
    isCreateClasses = "",
    setSort = () => {},
    isSearch = false,
    search = "",
    setSearch = () => {},
    onSearchChange = () => {},
    text = "",
    isCreate = false,
    createText = "",
    mobcreateText = false,
    onCreateClick = () => {},
    isDelete = false,
    subTitle = "",
    deleteText = "",
    onDeleteClick = () => {},
    isBackBtn = false,
    onBackClick = () => {},
    onMobCreateClick = () => {},
    isAccountDetailPage = false,
    handleEmailClick = () => {},
    isLoading = false,
  } = props;

  const profileDropdownHandle = () => {
    setProfileDropdown(!profileDropdown);
  };

  const filterDropdownHandle = () => {
    dispatch({
      type: "openBottomSheet",
      payload: {
        data: {
          modalType: "filter",
          title: "Filter",
          className: "px-0 pb-0",
          options,
          setSort,
          sort,
          setSortValue,
        },
        path: `Filter/Filter`,
      },
    });
  };

  const changePassword = () => {
    profileDropdownHandle();
    dispatch({
      type: "openBottomSheet",
      payload: {
        data: {
          modalType: "changePassword",
          title: "Change Password",
          className: "md:px-0 px-4 pb-0",
        },
        path: `change-password/ChangePassword`,
      },
    });
  };

  const DropdownHandle = () => {
    dispatch({
      type: "openBottomSheet",
      payload: {
        data: {
          modalType: "filter",
          title: "Other",
          className: "px-0 pb-0",
          options,
          handleEmailClick,
        },
        path: `MailOptions/MailOptions`,
      },
    });
  };

  return (
    <div
      className={`card-header flex md:flex-row flex-col md:justify-between md:rounded-lg mb-4 md:static fixed z-10 top-0 left-0 right-0 md:bg-white-300 bg-white-100 md:h-[70px] ${
        isSearch ? "h-[140px]" : "h-[70px]"
      }`}
    >
      <div className="flex flex-row justify-between p-3 md:border-0 border-b border-grey-2100">
        <div className="flex flex-row items-center">
          {isBackBtn ? (
            <button
              type="button"
              className="md:hidden block btn bg-transparent min-w-[20px] ps-0  capitalize w-fit border-0"
              onClick={onBackClick}
            >
              <BackArrow />
            </button>
          ) : null}
          <div className="title-img rounded-lg	p-2 mr-2.5">
            {props.img ? <img src={props.img} alt="title-img" /> : props.svg}
          </div>
          <div className="mr-4">
            <p className="text font-normal text-xs">{text}</p>
            <div className="md:block hidden flex flex-row items-center">
              <p className="title font-bold	text-sm">
                {subTitle || userData?.fsoName}
              </p>
            </div>
            <div className="md:hidden block flex flex-row items-center">
              <p className="title mobile-header-subtitle subTitle font-bold	text-sm">
                {sortValue || subTitle || userData?.fsoName}
              </p>
            </div>
          </div>
          {isFilter ? (
            <div className="mr-4 md:block hidden">
              <Filter options={options} sort={sort} setSort={setSort} />
            </div>
          ) : null}
        </div>
        <div className="md:hidden block flex items-center">
          {isFilter ? (
            <div className="relative inline-block text-left">
              <div>
                <div
                  onClick={filterDropdownHandle}
                  className="rounded-full mr-2 text-white w-10 h-10  flex justify-center items-center cursor-pointer"
                >
                  <FilterSVg />
                </div>
              </div>
            </div>
          ) : null}
          {isAccountDetailPage ? (
            <div className="relative inline-block text-left">
              <div>
                <div
                  onClick={DropdownHandle}
                  className="rounded-full mr-2 text-white w-10 h-10  flex justify-center items-center cursor-pointer"
                >
                  <MoreSVg color="#E11B22" />
                </div>
              </div>
            </div>
          ) : null}
          <div className="relative inline-block text-left">
            <div>
              <Tooltip
                trigger={`click`}
                placement="bottomRight"
                overlay={
                  <div className="py-1" role="none">
                    {/* <a
                      href="#"
                      className="text-black-100 text-base block px-2 py-3 cursor-pointer text-center border-b-2"
                      role="menuitem"
                      tabindex="-1"
                      id="menu-item-0"
                    >
                      My Profile
                    </a> */}
                    <a
                      onClick={changePassword}
                      className="text-black-100 text-base block px-2 py-3 cursor-pointer text-center border-b-2"
                      role="menuitem"
                      tabindex="-1"
                    >
                      Change Password
                    </a>
                    <a
                      className="text-black-100 text-base block px-2 py-3 cursor-pointer text-center"
                      role="menuitem"
                      tabindex="-1"
                      id="menu-item-2"
                      onClick={() => logout()}
                    >
                      Logout
                    </a>
                  </div>
                }
                overlayClassName="md:w-[180px] w-[180px] opacity-100 pageheader-tooltip"
                overlayInnerStyle={{
                  backgroundColor: "#F4F3F4",
                  left: "100%",
                  borderRadius: "4px",
                }}
              >
                <div className="rounded-full mr-2 bg-primary text-white-100 w-10 h-10  flex justify-center items-center cursor-pointer">
                  {getNameFirstLetter(userData?.fsoName || "D")}
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="static z-0 flex h-full flex-row justify-between items-center">
        {isSearch ? (
          <div className="md:w-[280px] grow p-3 pe-0 me-3">
            <Search
              search={search}
              setSearch={setSearch}
              onChange={onSearchChange}
            />
          </div>
        ) : null}
        {isCreate ? (
          <button
            className="md:block hidden btn btn-secondary-outlined me-3 capitalize"
            onClick={onCreateClick}
          >
            {createText ? createText : "New"}
          </button>
        ) : null}
        {isCreate ? (
          <button
            className={`md:hidden btn block btn-primary z-10 !capitalize fixed m-5 mb-7 ${isCreateClasses}`}
            onClick={onMobCreateClick}
            style={{
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            }}
          >
            {mobcreateText ? (
              <img src={mobcreateText} className="mx-auto" />
            ) : createText ? (
              createText
            ) : (
              "New"
            )}
          </button>
        ) : null}
        {isAccountDetailPage ? (
          <>
            {options?.map((dt, i) => (
              <button
                key={i}
                className="md:block hidden btn btn-secondary-outlined me-3 capitalize"
                onClick={() => handleEmailClick(dt?.value, false)}
                disabled={isLoading}
              >
                {dt?.label}
              </button>
            ))}
          </>
        ) : null}
        {isDelete ? (
          <button
            className="btn btn-primary-outlined capitalize p-3 me-3"
            onClick={onDeleteClick}
          >
            {deleteText ? deleteText : "Delete"}
          </button>
        ) : null}
        {isBackBtn ? (
          <button
            type="button"
            className="md:flex md:items-center hidden btn btn-secondary-outlined capitalize me-3"
            onClick={onBackClick}
            style={{ minWidth: 80 }}
          >
            <IoMdArrowRoundBack className="mr-1.5 scale-150" />
            Back
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default PageHeader;
